import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from './contexts/UserContext';
import useLog from './hooks/useLog';

const ProtectedRoute = ({ component}) => {
  const { loggedInState } = useContext(UserContext);
  const { LogVerbose } = useLog();

  LogVerbose(`ProtectedReoute check: signedInState: ${loggedInState}`);

  if (loggedInState === 'CMSAuthenticated') {
    return component;
  } else {
    return <Navigate to="/login" />;
  }
};

export { ProtectedRoute };